import { useRoutes } from 'react-router-dom';

import LoggedInRoutes from './LoggedInRoutes';
import LoggedInRoutesMinimal from './LoggedInRoutesMinimal';
import LoggedOutRoutes from './LoggedOutRoutes';
import PublicRoutes from './PublicRoutes';
import RedirectRoutes from './RedirectRoutes';

export default function Routes() {
  return useRoutes([
    LoggedInRoutes,
    LoggedInRoutesMinimal,
    LoggedOutRoutes,
    PublicRoutes, // Move this up
    RedirectRoutes // Keep this last
  ]);
}
